import { useState, useEffect } from "react";
import { FormControl, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { BASE_URL, HEADERS } from "../../utils/constant";
import ApplyLeaveModal from "../../components/Modals/LeaveModel";
import AssignLeaveModal from "../../components/Modals/AssignLeavesModel";
import NoData from "../../components/NoData";
import Loader from "../../components/Loader";
import { useCommonContext } from "../../utils/context";
import LeaveViewModal from "../../components/Modals/HisstoryModals/LeaveViewModel";
import CommonButton from "../../components/CommonButton";
import Pagination from "../../components/Pagination";
import StatusBadge from "../../components/StatusBadge";

const MyLeaveReport = () => {
  const [leaves, setLeaves] = useState([]);
  const [showApplyLeaveModal, setShowApplyLeaveModal] = useState(false);
  const [editLeaveData, setEditLeaveData] = useState(null);
  const [isUpdateStatus, setIsUpdateStatus] = useState(false);
  const [showAssignLeaveModal, setShowAssignLeaveModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchUser, setSearchUser] = useState("");

  const [statusFilter, setStatusFilter] = useState("");
  const [dateFilter, setDateFilter] = useState("");
  const userId = localStorage.getItem("userId");
  const userPermissions = localStorage.getItem("user_permissions");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [itemOffset, setItemOffset] = useState(0);
  const [selectedLeave, setSelectedLeave] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = leaves.slice(itemOffset, endOffset);

  const { user } = useCommonContext();

  const [itemuserOffset, setItemuserOffset] = useState(0);
  const [currentuserPage, setCurrentuserPage] = useState(1);
  const [totaluserPages, setTotaluserPages] = useState(0);
  const [itemsuserPerPage, setItemsuserPerPage] = useState("all");
  const enduserOffset = itemuserOffset + itemsuserPerPage;

  const [showViewModal, setShowViewModal] = useState(false);

  useEffect(() => {
    setCurrentuserPage(1);
  }, [searchUser]);

  useEffect(() => {
    fetchLeaves(currentPage);
  }, [currentPage, itemsPerPage, searchTerm, statusFilter, dateFilter]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, statusFilter, dateFilter]);

  const fetchLeaves = async (page = 1) => {
    setLoading(true);
    try {
      const params = {
        page: page,
        page_size: itemsPerPage,
      };
      if (searchTerm) params.search = searchTerm;
      if (statusFilter) params.status = statusFilter;

      if (dateFilter) {
        const today = new Date();
        let startDate;

        switch (dateFilter) {
          case "today":
            startDate = today;
            break;
          case "lastWeek":
            startDate = new Date(today.setDate(today.getDate() - 7));
            break;
          case "last15Days":
            startDate = new Date(today.setDate(today.getDate() - 15));
            break;
          case "lastMonth":
            startDate = new Date(today.setMonth(today.getMonth() - 1));
            break;
          default:
            startDate = null;
        }

        if (startDate) {
          params.start_date = startDate.toISOString().split("T")[0];
        }
      }

      const response = await axios.get(
        `${BASE_URL}/users/leaves?userId=${userId}`,
        {
          headers: HEADERS,
          params: params,
        },
      );

      if (response.data) {
        setLeaves(response.data.results || []);
        setTotalPages(Math.ceil(response.data.total_pages));
        setCurrentPage(page);
        setLoading(false);
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCurrentPage(1);
        fetchLeaves(1);
      } else {
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePageClick = (selectedPage) => {
    const newPage = selectedPage.selected + 1;
    setCurrentPage(newPage);
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleApplyLeave = () => {
    setEditLeaveData(null);
    setIsUpdateStatus(false);
    setShowApplyLeaveModal(true);
  };

  const handleEditLeave = (leave) => {
    setEditLeaveData(leave);
    setIsUpdateStatus(false);
    setShowApplyLeaveModal(true);
  };

  const handleUpdateStatus = (leave) => {
    setEditLeaveData(leave);
    setIsUpdateStatus(true);
    setShowApplyLeaveModal(true);
  };

  const handleViewLeave = (leave) => {
    setSelectedLeave(leave);
    setShowViewModal(true);
  };

  const handleDeleteLeave = async (leaveId) => {
    try {
      await axios.delete(`${BASE_URL}/users/leaves/${leaveId}`, {
        headers: HEADERS,
      });
      toast.success("Leave deleted successfully.");
      setLeaves(leaves.filter((leave) => leave.id !== leaveId));
      fetchLeaves(currentPage);
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        const errorMessage = error.response.data.error;
        toast.error(errorMessage);
      }
    }
  };

  const calculateDays = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const diffTime = Math.abs(end - start);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays;
  };

  return (
    <div className="container-fluid ">
      <div className="mt-3 container-header mb-3">
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <h4 className="mb-0">Welcome, {user?.first_name}</h4>

          <div className="d-none d-md-flex align-items-center gap-2 flex-grow-1">
            <FormControl
              type="text"
              placeholder="Search Here..."
              className="uniform-input search-text"
              disabled={leaves?.length === 0 && !searchTerm}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ maxWidth: "250px" }}
            />
            <Form.Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              disabled={leaves?.length === 0 && !statusFilter}
              className="uniform-input"
              style={{ maxWidth: "180px" }}
            >
              <option value="">All Status</option>
              <option value="Submitted">Submitted</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </Form.Select>

            {userPermissions.includes("leavereport_apply_leave") && (
              <CommonButton
                className="uniform-button me-2"
                onClick={handleApplyLeave}
                style={{ whiteSpace: "nowrap" }}
              >
                Apply Leave
              </CommonButton>
            )}
          </div>

          <div className="d-flex d-md-none flex-column gap-2 w-100">
            <FormControl
              type="text"
              placeholder="Search Here..."
              className="uniform-input search-text"
              disabled={leaves?.length === 0 && !searchTerm}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Form.Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              disabled={leaves?.length === 0 && !statusFilter}
              className="uniform-input"
            >
              <option value="">All Status</option>
              <option value="Submitted">Submitted</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </Form.Select>

            {userPermissions.includes("leavereport_apply_leave") && (
              <CommonButton
                className="uniform-button"
                onClick={handleApplyLeave}
                style={{ width: "100%" }}
              >
                Apply Leave
              </CommonButton>
            )}
          </div>
        </div>

        <div
          className="d-flex flex-column flex-md-row align-items-start align-items-md-center px-3 py-2 mb-3"
          style={{
            background: "#f8fbff",
            borderRadius: "8px",
            border: "1px solid #cceeff",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.08)",
            fontSize: "0.9rem",
            gap: "10px",
          }}
        >
          <div className="d-flex align-items-center gap-1 me-md-4 mb-2 mb-md-0">
            <i className="bi bi-calendar-check text-primary"></i>
            <span className="text-primary">
              Casual Leave:{" "}
              <strong>{user?.allocated_casual_leave || "0"}</strong>
            </span>
          </div>

          <div className="d-flex align-items-center gap-1">
            <i className="bi bi-heart-pulse text-success"></i>
            <span className="text-success">
              Sick Leave: <strong>{user?.allocated_sick_leave || "0"}</strong>
            </span>
          </div>
        </div>
      </div>

      <div
        className={`table-responsive ${
          currentItems.length === 0 ? "" : "tabell"
        } `}
        style={{ height: "70vh" }}
      >
        {loading ? (
          <Loader />
        ) : (
          <>
            {currentItems.length > 0 ? (
              <table className="table  tstart">
                <thead className="thead">
                  <tr style={{ whiteSpace: "nowrap" }}>
                    {/* <th style={{ width: "100px" }}>S.No</th> */}
                    <th style={{ width: "250px" }}>Name</th>
                    <th style={{ width: "150px" }}>Phone No.</th>
                    <th style={{ width: "150px" }}>Role</th>
                    <th style={{ width: "150px" }}>Leave Type</th>
                    <th style={{ width: "200px" }}>From Date</th>
                    <th style={{ width: "200px" }}>To Date</th>
                    <th style={{ width: "80px" }}>Days</th>
                    <th style={{ width: "250px" }}>Reason</th>
                    <th style={{ width: "200px" }}>Status</th>
                    <th style={{ width: "200px" }}>Remark</th>
                    <th style={{ width: "150px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems?.map((leave, index) => (
                    <tr
                      key={leave.id}
                      onClick={() => handleViewLeave(leave)}
                      className="tbody"
                    >
                      <td
                        title={`${leave.userId.first_name} ${leave.userId.last_name}`}
                      >
                        <div className="d-flex align-items-center">
                          <span
                            className="badge bg-primary text-white me-2"
                            title={`User ID: ${leave.userId.id}`}
                          >
                            {leave.userId.id}
                          </span>
                          <div className="tdsubject">
                            {`${leave.userId.first_name} ${leave.userId.last_name}`}
                          </div>
                        </div>
                      </td>

                      <td title={leave.userId.phone_number}>
                        <div className="tdsubject">
                          {leave.userId.phone_number}
                        </div>
                      </td>

                      <td title={leave.userId.role}>
                        <div className="tdsubject badge bg-secondary text-white">
                          {leave.userId.role === "superuser"
                            ? "Manager"
                            : leave.userId.role === "agent"
                              ? "Executive"
                              : leave.userId.role}
                        </div>
                      </td>

                      <td title={leave.leave_type}>
                        <div className="tdsubject">{leave.leave_type}</div>
                      </td>

                      <td
                        title={new Date(leave.start_date).toLocaleDateString()}
                      >
                        <div className="tdsubject">
                          {new Date(leave.start_date).toLocaleDateString()}
                        </div>
                      </td>

                      <td title={new Date(leave.end_date).toLocaleDateString()}>
                        <div className="tdsubject">
                          {new Date(leave.end_date).toLocaleDateString()}
                        </div>
                      </td>

                      <td
                        title={`${calculateDays(
                          leave.start_date,
                          leave.end_date,
                        )} days`}
                      >
                        <div className="tdsubject">
                          {calculateDays(leave.start_date, leave.end_date)}
                        </div>
                      </td>

                      <td title={leave.reason}>
                        <div className="tdsubject">{leave.reason}</div>
                      </td>

                      <td title={leave.status}>
                        <StatusBadge status={leave.status} />
                      </td>

                      <td
                        title={
                          leave.status === "Approved"
                            ? leave.approved_remark || "—"
                            : leave.rejected_remark || "—"
                        }
                      >
                        <div className="tdsubject">
                          {leave.status === "Approved"
                            ? leave.approved_remark || "—"
                            : leave.rejected_remark || "—"}
                        </div>
                      </td>

                      <td style={{ padding: "6px 10px" }}>
                        <div className="d-flex justify-content-center">
                          {leave.status === "Submitted" && (
                            <>
                              {userPermissions?.includes(
                                "leavereport_change_leavereport",
                              ) && (
                                <FaEdit
                                  size={15}
                                  className="me-3 cursor-pointer text-primary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleEditLeave(leave);
                                  }}
                                />
                              )}
                              {userPermissions?.includes(
                                "leavereport_delete_leavereport",
                              ) && (
                                <FaTrashAlt
                                  size={15}
                                  className="text-danger"
                                  style={{ cursor: "pointer" }}
                                  title="Delete Leave"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDeleteLeave(leave.id);
                                  }}
                                />
                              )}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <NoData message="No Data Found" height="400px" />
            )}
          </>
        )}
      </div>

      {currentItems.length > 0 && (
        <Pagination
          totalPages={totalPages}
          itemsPerPage={itemsPerPage}
          handlePageClick={handlePageClick}
          handleItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {showApplyLeaveModal && (
        <ApplyLeaveModal
          show={showApplyLeaveModal}
          handleClose={() => setShowApplyLeaveModal(false)}
          leaveData={editLeaveData}
          onApplyLeave={() => fetchLeaves(currentPage)}
          isUpdateStatus={isUpdateStatus}
        />
      )}

      <AssignLeaveModal
        show={showAssignLeaveModal}
        handleClose={() => setShowAssignLeaveModal(false)}
        fetchLeaves={() => fetchLeaves(currentPage)}
      />

      <LeaveViewModal
        show={showViewModal}
        handleClose={() => setShowViewModal(false)}
        leaveId={selectedLeave?.id}
        leave={selectedLeave}
        currentPage={currentPage}
      />
    </div>
  );
};

export default MyLeaveReport;
